<template>
  <div 
    v-if="!showOnlyRecomended"
    :menuSequencingDataObserver="menuSequencingData"
    :id="'category_items_id_' + getSingleProductItemCategory?.categoryId"
    class="horizontall-scroll-anim"
    :selectedMenuCategoryForceProp="checkSepMenuPage ? getSelectedMenuCategory : ''"
  >
    <p :id="'element_catg_' + getSingleProductItemCategory?.categoryId"></p>
    <div
      v-if="
        moduleProps &&
        isCorrectModuleType &&
        Object.keys(getSingleProductItemCategory?.data || {})?.length > 0
      "
      class="cards-wrap mb30 clearfix options-api"
      :style="{ minHeight: minHeightCal + 'px' }"
    >
      <Observer 
        :options="getObserverOptions"
        @intersect="itisvisible" 
      />
      <div class="flex-row" :class="{ mb16: showSmallCards }">
        <span class="center-flexible-line"></span>
        <span
          ><h3
            class="card-catg-name"
            :class="[isAnchorLinkVariant ? 'color-slaty' : '']"
          >
            {{ getSingleProductItemCategory?.categoryName }}
          </h3></span
        >
        <span class="center-flexible-line"></span>
      </div>

      <Observer
        :options="{ rootMargin: '-50px' }"
        @intersect="itisvisibleTop"
      />
      <div 
        v-if="showList"
        class="cards-holder"
        :class="[shouldRibbonVisible ? 'card-ribbon' : '']"
      >
        <product-card
          v-for="(value, key, index) in getSingleProductItemCategory?.data"
          :key="key"
          :data-cardRounded="vpsProps.cardRounded"
          :data-cardSearchable="vpsProps.cardSearchable"
          :data-showUpsell="vpsProps.showUpsell"
          :data-showCrossell="vpsProps.showCrossell"
          :data-result="value"
          :data-index="index"
          :data-moduleProps="moduleProps"
          :data-counterText="
            'Showing ' +
            categoryName +
            ' | ' +
            (index + 1) +
            '/' +
            Object.keys(getSingleProductItemCategory?.data)?.length
          "
          :data-categoryId="getSingleProductItemCategory?.categoryId || '-1'"
          :data-type="getSingleProductItemCategory?.categoryName"
          :top10="shouldRibbonVisible"
          :ribbonIcon="ribbonTitleIcon"
          :ribbonTitleColor1="ribbonTitleColor1"
          :ribbonTitleColor2="ribbonTitleColor2"
          :ribbonTitle1="ribbonTitle1"
          :ribbonTitle2="ribbonTitle2"
        ></product-card>
      </div>
    </div>
    <Observer 
      :options="getObserverOptions"
      @intersect="itisvisible" 
      :style="{ bottom: 0 }" 
    />
  </div>
</template>

<script>
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import ProductCard from "./ProductCard.vue";
import Observer from "../assets/Observer.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import horizontalSwipe from "../helpers/horizontalSwipe";
import PageNames from "../config/pageNames";

export default {
  name: "VerticalProductScroll",
  props: ["dataResults", "moduleProps"],
  components: {
    ProductCard,
    Observer,
  },
  data() {
    return {
      isCorrectModuleType: false,
      vpsProps: {
        cardRounded: false,
        cardSearchable: false,
        showUpsell: true,
        showCrossell: true,
      },
      categoryName: "",
      defaultModuleProperties: {
        cardType: "video/static",
        itemsInScreen: "1.75",
        aspectRatio: "1",
        title: "Best Sellers",
        type: "VERTICAL_PRODUCT_SCROLL",
      },
      showList: false,
      isUpdated: false,
      parsedResults: [],
      isMenuSequenceProcessed: false,
      shouldRibbonVisible: false,
      ribbonTitleIcon: "",
      ribbonTitleColor1: "",
      ribbonTitleColor2: "",
      ribbonTitle1: "",
      ribbonTitle2: "",
    };
  },
  mounted() {
    this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
    this.defaultModuleProperties = Utility.tryJsonParse(
      this.moduleProps,
      this.defaultModuleProperties
    );
    this.checkModuleTypeToRender();

    this.categoryName = this.parsedResults?.[0]?.categoryName;
    this.processResultDataForStore(this.parsedResults);

    this.ribbonTitleIcon = this.defaultModuleProperties?.ribbonIcon;
    if (
      this.ribbonTitleIcon !== undefined &&
      this.ribbonTitleIcon !== "null" &&
      this.ribbonTitleIcon !== null &&
      this.ribbonTitleIcon
    ) {
      this.shouldRibbonVisible = true;
    }
    this.ribbonTitleColor1 = this.defaultModuleProperties?.ribbonTitleColor1;
    this.ribbonTitleColor2 = this.defaultModuleProperties?.ribbonTitleColor2;
    this.ribbonTitle1 = this.defaultModuleProperties?.ribbonTitle1;
    this.ribbonTitle2 = this.defaultModuleProperties?.ribbonTitle2;

    if (
      this.ribbonTitle1 === undefined ||
      this.ribbonTitle1?.toLowerCase() === "null"
    ) {
      this.ribbonTitle1 = "";
    }
    if (
      this.ribbonTitle2 === undefined ||
      this.ribbonTitle2?.toLowerCase() === "null"
    ) {
      this.ribbonTitle2 = "";
    }
  },
  methods: {
    checkSepMenuPage() {
      let linkRewrite = Utility.getCurrentStoreFolder(); // /menu/
      linkRewrite = "pwa" + linkRewrite;
      if (linkRewrite === "pwa/menu/") {
        return true;
      }
      return false;
    },
    checkModuleTypeToRender() {
      if (this.defaultModuleProperties?.type === "VERTICAL_PRODUCT_SCROLL") {
        this.isCorrectModuleType = true;
      }
    },
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCT_ITEMS, data);
      this.$store.commit(
        keyMapsMutation.UPDATE_CART_FROM_LOCAL_STORAGE,
        this.$store.state.ProductItems.unfilteredProductItems
      );
      this.$store.commit(
        keyMapsMutation.LOAD_UNIQUE_CART_ITEMS,
        this.$store.state.Cart.cartItems
      );

      let _ = LocalStorageFunc.getSessionStorageKey("orderFiltersData");
      this.$store.commit(keyMapsMutation.FILTER_PRODUCT_ITEMS, {
        filterProductItem: [
          ...(_.appliedFilters || []),
          ...(_.appliedSortFilters || []),
        ],
        cartData: this.$store.state.Cart.cartItems,
        cartQuantitiy: this.$store.getters[keyMapsGetter.CART_QUANTITY],
      });
    },
    itisvisibleTop() {
      if (!this.isUpdated) {
        //Amplitude impression event load
        let sectionName = this.getSingleProductItemCategory?.categoryName;
        if (sectionName) {
          sectionName = sectionName.toLowerCase() + " cards";
        }
        const preEventObj = {
          positionWithinSection: 1,
          category:
            this.getSingleProductItemCategory?.categoryName?.toLowerCase(),
        };
        const eventObj = Utility.amplitudeEventObj(
          "impression",
          sectionName,
          "14",
          preEventObj
        );
        setEvents("amplitude", "Impression", eventObj);
        this.isUpdated = true;
      }
    },
    itisvisible() {
      this.showList = true;
    },
    isMenuSequencingEnabled() {
      return window?._siteProps_?.props?.enableMenuSequencing === "true";
    },
    toggle(className, displayState){
      var elements = document.getElementsByClassName(className)
      for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
      }
    }
  },
  computed: {
    getSingleProductItemCategory() {
      return this.$store.getters[
        keyMapsGetter.GET_SINGLE_PRODUCT_ITEM_CATEGORY
      ](this.categoryName);
    },
    openAllCards() {
      return this.$store.state.ProductItems.openAllCards;
    },
    showSmallCards() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_b" ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_u"
      ) {
        return true;
      } else {
        return false;
      }
    },
    minHeightCal() {
      if (window.screen.width >= 740) {
        return;
      }
      let count = Object.keys(
        this.getSingleProductItemCategory?.data || {}
      )?.length;
      // console.log('count all...', this.getSingleProductItemCategory?.categoryName, count, 366*count+37);
      if (!this.showSmallCards) {
        return 366 * count + 37;
      } else {
        return 196 * count + 37;
      }
    },
    menuSequencingData() {
      let _ = this.$store.state.ProductItems.menuSequencingData;
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        _[this.parsedResults[0]?.categoryId] &&
        !this.isMenuSequenceProcessed &&
        this.isMenuSequencingEnabled() &&
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_R
      ) {
        this.isMenuSequenceProcessed = true;
        this.processResultDataForStore(
          Utility.sequencedProductItems(
            this.parsedResults,
            _[this.parsedResults[0]?.categoryId]
          )
        );
      }
    },
    isAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S) ||
        (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U) ||
        (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL) ||
        (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y) ||
        (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W) ||
          (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X) ||
          (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL) ||
          (LocalStorageFunc.getSessionStorageKey('previousLinkRewrite') ===
          PageNames.NEXTGEN_LINKREWRITE_HOME)
      ) {
        this.addHorizontalSwipe;
        return true;
      } else {
        return false;
      }
    },
    addHorizontalSwipe() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y
      ) {
        let ele = document.getElementById("category_items_id_" + this.getSingleProductItemCategory?.categoryId);
        ele.addEventListener('touchstart', horizontalSwipe.handleTouchStart, false);        
        ele.addEventListener('touchmove', horizontalSwipe.handleTouchMove, false);
      }
    },
    getObserverOptions() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U
      ) {
        return { root: null,threshold: 0,rootMargin: '0%' };
      }
      else {
        return {rootMargin: '750px'};
      }
    },
    showOnlyRecomended() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        this.checkSeparateLandingPage &&
          (exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
            VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
            VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
            VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
            VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y) ||
          Utility.getLinkRewriteFromSiteprops() ===
            PageNames.NEXTGEN_LINKREWRITE_HOME
      ) {
        this.toggle('horizontall-scroll-anim', 'none');
        return true;
      }
      else {
        return false;
      }
    },
    checkSeparateLandingPage(){
      let linkRewrite = Utility.getCurrentStoreFolder();// /menu/
      linkRewrite = 'pwa'+linkRewrite;
      if(linkRewrite === 'pwa/landing/'){
        return true;
      }
      else {
        return false;
      }
    },
    getSelectedMenuCategory() {
      const selectedCategory =
        this.$store.getters[keyMapsGetter.GET_SELECTED_MENU_CATEGORY]; 
      if (
        selectedCategory.category ===
          this.getSingleProductItemCategory?.categoryName &&
        !this.showList
      ) {
        this.showList = true;
      }
    },
  },
};
</script>
